
import Vue from 'vue';
import Idea from '../components/Locals/Idea.vue';
import Discounts from '../components/Locals/HowItWorks.vue';
import JoinCTA from '../components/Locals/JoinUsCTA.vue';
import Video from '../components/Video.vue';
import Map from '../components/Locals/Map.vue';
import ContactCTA from '../components/Locals/ContactCTA.vue';
import Contact from '../components/Locals/Contact.vue';
export default Vue.extend({
  name: 'Locals',
  components: {
    Idea,
    Discounts,
    JoinCTA,
    Map,
    Video,
    ContactCTA,
    Contact,
  },
});
